export default __webpack_public_path__ + "static/media/Claudia 9781408316757.8d97be45.jpg";